import React from 'react'

const Modal = ({ title, visible, toggle, children, w = "w-1/2", h = "h-1/2", align = "items-center", top = "", bottom = "" }) => {
    return (
        <div id="modal" className={ `${ visible ? 'scale-100' : 'scale-0' } overflow-hidden overflow-y-scroll fixed z-30 ${bottom} top-0 left-0 w-screen h-screen flex ${align} justify-center bg-gray-700 bg-opacity-50 transform transition-transform duration-300` }>
            {/* Modal content */}
            <span className="z-0 overflow-hidden absolute w-full h-full" onClick={ toggle } />
            <div className={ `z-10 bg-white ${w} ${h} p-6 ${top}` }>
                <div className="sm:flex sm:justify-between sm:items-center mb-2">
                    <p className="font-extrabold text-3xl mb-0">{ title }</p>
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                        <button onClick={ toggle } id="closebutton" type="button" className="focus:outline-none">
                            {/* Hero icon - close button */}
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </button>
                    </div>
                </div>
                { children }
            </div>
        </div>
    )
}

export default Modal